import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { SurveyConfig, GeneratedQuestion } from '@/contexts/SurveyContext';

interface SurveyGenerationResponse {
  questions: GeneratedQuestion[];
}

export const useSurveyGeneration = () => {
  return useMutation({
    mutationFn: async (config: SurveyConfig): Promise<GeneratedQuestion[]> => {
      const { data, error } = await supabase.functions.invoke('generate-survey-questions', {
        body: { config }
      });

      if (error) {
        console.error('Error generating survey:', error);
        throw new Error('Failed to generate survey questions');
      }

      const response = data as SurveyGenerationResponse;
      return response.questions;
    },
  });
};